export default __webpack_public_path__ + "static/media/mg_img.117aa8e1.png";